import Api from '@/api/index.js';

export default {
    getData(pathToList) {
        return Api.request('get', `filemanager/data?folder=${pathToList}`)
            .then(response => response.data);
    },

    uploadFile() {
        return Api.request('post', `filemanager/uploads/add`)
            .then(response => response.data);
    },

    createFolder(folderName, currentFolder) {
        return Api.request('post', `filemanager/actions/create-folder`, {
                folder: folderName,
                current: currentFolder,
            })
            .then(response => response.data);
    },

    removeDirectory(currentFolder) {
        return Api.request('post', `filemanager/actions/delete-folder`, {
                current: currentFolder,
            })
            .then(response => response.data);
    },

    getInfo(file) {
        return Api.request('post', `filemanager/actions/get-info`, { file: file })
            .then(response => response.data);
    },

    removeFile(file) {
        return Api.request('post', `filemanager/actions/remove-file`, { file: file })
            .then(response => response.data);
    },
};



// WEBPACK FOOTER //
// ./src/components/filemanager/api.js